import React from 'react'
import SubLayout from '../../components/Layout/SubLayout'
import strings from "../../components/Language";
import _ from 'lodash';

//  CSS
import './../../assets/styles/style.scss';
import './wallet.scss';
import { IconSwap } from '../../components/Icons';

import { toast } from 'react-toastify';
import axios from 'axios';
import { api } from '../../components/config/api.js';
import { getToken, storeUserData } from '../../components/Util';

import LoaderContext from '../../components/Loader/LoaderContext.js';
import moment from 'moment';

class TransferDetailsScreen extends React.Component {

    static contextType = LoaderContext;
    constructor(props) {
        super(props);
        this.state = {
            access_token: "",
            user_data: {},
            data: [],
            nextPageLink: "",
            prevPageLink: "",
        }
    }

    async componentDidMount() {
        var token = await getToken();
        if (token) {
            await storeUserData(token);
            this.setState({ access_token: token });
            setTimeout(() => {
                this.getData();
            });
        }
    }

    getData() {
        const { setLoading } = this.context;
        setLoading(true);
        var self = this;
        axios({
            method: 'GET',
            url: api.transfer_report,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json',
                'Accept-Language': strings.getLanguage()
            }
        }).then(function (ress) {

            if (ress.data.data && ress.data.data.length > 0) {
                self.setState({
                    data: ress.data.data,
                    nextPageLink: ress.data.links.next,
                    prevPageLink: ress.data.links.prev,
                });
            } else {
                if (ress.data.validation && ress.data.validation.length !== 0) {
                    _.forEach(ress.data.validation, function (value) {
                        if (value[0]) {
                            toast.error(value[0]);
                        }
                    });
                } else {
                    toast.error(ress.data.message);
                }
            }
            setLoading(false);
        }).catch(function (e) {
            setLoading(false);
        });
    };

    getNextData(API) {
        if (!API) {
            toast.error(strings.URI_not_found);
            return false;
        }
        var self = this;
        self.setState({
            nextPageLink: "",
            prevPageLink: "",
        });
        const { setLoading } = this.context;
        setLoading(true);
        axios({
            method: 'GET',
            url: API,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json',
                'Accept-Language': strings.getLanguage()
            }
        }).then(function (ress) {

            if (ress.data.data && ress.data.data.length > 0) {
                self.setState({
                    data: [...self.state.data, ...ress.data.data],
                    nextPageLink: ress.data.links.next,
                    prevPageLink: ress.data.links.prev,
                });
            } else {
                if (ress.data.validation && ress.data.validation.length !== 0) {
                    _.forEach(ress.data.validation, function (value) {
                        if (value[0]) {
                            toast.error(value[0]);
                        }
                    });
                } else {
                    toast.error(ress.data.message);
                }
            }
            setLoading(false);
        }).catch(function (e) {
            setLoading(false);
        });
    };

    render() {
        return (
            <SubLayout data={{ "title": strings.transfer_details }}>
                <div className='wl-page offset-md-4 col-md-4'>
                    {this.state.data && this.state.data.length > 0 ?
                        <ul className='wl-list'>
                            {this.state.data.map((item, i) => (
                                <li key={item.id || i} className='wl-tx'>
                                    <div className='wl-tx-head'>
                                        <span className='wl-row-icon is-swap'><IconSwap size={18} /></span>
                                        <span className='wl-row-main'>
                                            <span className='wl-tx-amount'>{item.amount ?? 0} <small>{strings.usdt}</small></span>
                                            <span className='wl-row-sub'>{item.created_at ? moment(item.created_at).format("YYYY-MM-DD HH:mm:ss") : "-"}</span>
                                        </span>
                                    </div>
                                    {item.description ?
                                        <div className='wl-tx-desc'>{item.description}</div>
                                        : null}
                                </li>
                            ))}
                        </ul>
                        : <div className='wl-empty'>{strings.no_records_found}</div>}

                    {this.state.nextPageLink ?
                        <button type="button" className='m-btn m-btn-ghost wl-load-more' onClick={() => this.getNextData(this.state.nextPageLink)}>
                            {strings.Load_More}
                        </button>
                        : null}
                </div>
            </SubLayout>
        );
    }
}

export default TransferDetailsScreen;
